module.exports = __webpack_public_path__ + "static/img/QLD-3.96e843f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-3.jpg
// module id = WSyV
// module chunks = 0